import React from 'react';

import LoadingAnimation from '../../../components/LoadingAnimation';
import { useStyles } from '../checkoutDrawer.styles';

function ProcessingView () {
    const classes = useStyles();

    return (
        <div className={classes.processingContainer}>
            <LoadingAnimation />
            <p className={classes.processingText}>Securing your subscription…</p>
        </div>
    );
}

export default ProcessingView;
